<template>
  <div class="projectLevelEvents"></div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@loreal/eventbus-js';

export default {
  name: 'rfp-mctb-events',
  props: {
    productDataLayer: { type: Object, required: true },
  },
  created() {
    eventBus.on('rfp-mctb-datalayer-event-new', () => {
      eventBus.emit('rfp-mctb-datalayer-event', this.productDataLayer);
    });
  },
};
</script>
